module.exports = __webpack_public_path__ + "img/palmar-room-4.b9341528.jpg";